import styled from '@emotion/styled';
import { device } from '@landsbankinn/ui';
import React, { useState } from 'react';
import { useSpring, animated } from 'react-spring';

interface MobileSubnavProps {
  title: React.ReactNode;
  items: React.ReactNode;
  cta: React.ReactNode;
  hasItems?: boolean;
}

const Host = styled.div`
  position: sticky;
  top: 0;
  z-index: 13;
  @media (min-width: 950px) {
    display: none;
  }
`;

const Title = styled.span`
  margin-right: 15px;
  font-family: ${(props) => props.theme.font.family};
  font-weight: 700;
  font-size: 20px;
  flex: 1;
  text-align: left;
`;

const SingleTitle = styled(Title)`
  padding: 2px 40px 0;
  padding: ${(props) => `2px ${props.theme.containerGutter}px 0`};

  @media ${device.mobile} {
    padding: ${(props) => `2px ${props.theme.breakpoints.sm.gutter}px 0`};
  }
`;

const DropdownButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 80px;
  margin-right: 15px;
  cursor: pointer;

  padding: ${(props) => `2px ${props.theme.containerGutter}px 0`};

  @media ${device.mobile} {
    padding: ${(props) => `2px ${props.theme.breakpoints.sm.gutter}px 0`};
  }
`;

const Top = styled.div`
  background: white;
  position: relative;
  z-index: 12;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 80px;
`;

const Sheet = styled.div`
  top: 80px;
  left: 0;
  right: 0;
  position: absolute;
  overflow: hidden;
`;

const Items = styled(animated.ul)`
  position: relative;
  list-style: none;
  padding-bottom: 60px;
  margin: 0;
`;

export const SubItem = styled.li<{ active?: boolean }>`
  border: none;
  padding: 0 40px;
  margin: 0;
  a {
    position: relative;
    display: block;
    padding: 13px 0;
    border-bottom: 1px solid #f5f7f7;

    ${(props) => props.active && 'color: #ccc;'};

    &:after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 0;
      height: 1px;
      background-color: ${(props) => props.theme.colors.primary};
      transition: width 200ms ease-in-out;
    }

    &:hover {
      &:after {
        width: 32px;
      }
    }
  }
`;

const Background = styled(animated.div)`
  position: absolute;
  top: 0;
  bottom: 10px;
  left: 0;
  right: 0;
  background: white;
  pointer-events: none;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

const ArrowSvg = styled.svg<{ open?: boolean }>`
  transition: transform 400ms ease-in-out;
  transform: ${(props) => (props.open ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

const Cta = styled.div`
  padding-right: 40px;
  > a {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 4px;
  }
`;

export function MobileSubnav({
  title,
  items,
  cta,
  hasItems,
}: MobileSubnavProps) {
  const [open, setOpen] = useState(false);
  const background = useSpring({
    y: open ? '0%' : '-100%',
    delay: open ? 0 : 200,
  });
  const itemsStyle = useSpring({
    opacity: open ? 1 : 0,
    y: open ? 0 : -20,
    delay: open ? 200 : 0,
  });

  return (
    <Host>
      <Top>
        {!hasItems && <SingleTitle>{title}</SingleTitle>}
        {hasItems && (
          <>
            <DropdownButton onClick={() => setOpen((f) => !f)}>
              <Title>{title}</Title>
              <ArrowSvg open={open} width="16" height="10" viewBox="0 0 16 10">
                <path
                  fill="none"
                  fillRule="evenodd"
                  stroke="#1E3D5A"
                  strokeWidth="2"
                  d="M14.545455.909091L8 8.272727 1.454545.909091"
                />
              </ArrowSvg>
            </DropdownButton>
            {cta && <Cta>{cta}</Cta>}
          </>
        )}
      </Top>
      <Sheet style={{ pointerEvents: open ? 'auto' : 'none' }}>
        <Background style={background} />
        <Items style={itemsStyle}>
          {items}
          {/* <Cta>{cta}</Cta> */}
        </Items>
      </Sheet>
    </Host>
  );
}
